module.exports = {
	"(all_markup_percentsign_will_base_on_this_price)": "(All markup % will base on this price.)",
	"(height)": "(Height)",
	"(inch)": "(Inch)",
	"(inches)": "(In.)",
	"(length)": "(Length)",
	"(mm_unit)": "(MM Unit)",
	"(no_sale_will_be_allowed_lower_than_this_price)": "(No sale will be allowed lower than this price.)",
	"(num)": "(Num)",
	"(pkg_size)": "(Pkg Size)",
	"(pkg_size_1)": "(Pkg Size 1)",
	"(pkg_size_1_new)": "(Pkg Size 1)",
	"(pkg_size_2)": "(Pkg Size 2)",
	"(pkg_size_2_new)": "(Pkg Size 2)",
	"(pkg_size_3_new)": "(Pkg Size 3)",
	"(pkg_type)": "(Pkg Type)",
	"(ref_no)": "(Ref No.)",
	"(width)": "(Width)",
	")__action_denied_": "). Action denied.",
	"00_dashsign_07_days": "00 - 07 Days",
	"00_dashsign_30_days": "00 - 30 Days",
	"08_dashsign_30_days": "08 - 30 Days",
	"0_VIP_VP": "0 - VIP - VP",
	"1_wholesale_distributor_WH": "1 - Wholesale Distributor - WH",
	"2_asia_supermarket_AS": "2 - Asia Supermarket - AS",
	"2_month": "2 Months",
	"31_dashsign_60_days": "31 - 60 Days",
	"3_month": "3 Months",
	"3_restaurant_RE": "3 - Restaurant - RE",
	"4_broker_trader_import_BK": "4 - Broker Trader Import - BK",
	"4_wks_sale": "4 WKS Sale",
	"5_processor_prison_military_airline_school_club_PS": "5 - Processor Prison Military Airline School Club - PS",
	"61_dashsign_90_days": "61 - 90 Days",
	"6_none_asian_supermarket_NS": "6 - None Asian Supermarket - NS",
	"7_online_order_OO": "7 - Online Order - OO",
	"8_cash_carry_CC": "8 - Cash Carry - CC",
	"91_plussign_days": "91+ Days",
	"9_other_OT": "9 - Other - OT",
	"account": "Account",
	"account_payable": "Accounts Payable",
	"account_payable_payment_report": "Accounts Payable (Payment Report)",
	"account_payment_term": "Account Payment Term",
	"account_receivable": "Accounts Receivable",
	"account_receivable_receive_report": "Accounts Receivable (Receive Report)",
	"action": "Action",
	"action_log": "Action Log",
	"action_name": "Action Name",
	"active": "Active",
	"active_customer": "Active Customer",
	"active_schedule": "Active Schedule",
	"active_vendor": "Active Vendor",
	"add": "Add",
	"add_a_new_category": "Add a New Category",
	"add_a_new_group": "Add a New Group",
	"add_a_new_payment_term": "Add A New Payment Term",
	"add_agent": "Add Agent",
	"add_another_product": "Add Another Product",
	"add_buyer": "Add Buyer",
	"add_customer": "Add Customers",
	"add_driver": "Add Driver",
	"add_invoice": "Add Invoice",
	"add_new_bin": "Add New Bin",
	"add_new_favorite": "Add New Favorite",
	"add_new_route": "Add New Route",
	"add_new_zone": "Add New Zone",
	"add_non_product": "Add Non Product",
	"add_payment_term": "Add Payment Term",
	"add_pickup": "Add Pickup",
	"add_purchase_order": "Add Purchase Order",
	"add_shipping_address": "Add Shipping Address",
	"add_vendor": "Add Vendor",
	"additional_order": "Additional Order",
	"address": "Address",
	"address_attribute": "Address Attribute",
	"adjust": "Adjust",
	"adjust_some_or_all_of_the_selected_inventory": "Adjust some or all of the selected inventory",
	"adjustment": "Adjustment",
	"adjustment_date": "Adjustment Date",
	"adjustment_quantity": "Adjustment Quantity",
	"adjustments": "Adjustments",
	"admin": "Admin",
	"admin_password": "Admin Password",
	"admin_tools": "Admin Tools",
	"advanced_search": "Advanced Search",
	"afg_choice": "AFG Choice",
	"afternoon": "afternoon",
	"agent_information": "Agent Information",
	"agent_name": "Agent Name",
	"agent_num": "Agent No.",
	"agents": "Agents",
	"alcohol": "Alcohol",
	"all": "All",
	"all_bins": "All Bins",
	"all_locations": "All Locations",
	"all_products": "All Products",
	"all_taxable": "All Taxable",
	"alt_phone": "Alt. Phone",
	"amount": "Amount",
	"ao": "AO",
	"ap_aged_report": "AP Aged Report",
	"ap_aged_report_detail": "AP Aged Report Detail",
	"ap_name": "AP Name.",
	"ap_num": "AP No.",
	"ap_phone": "AP Phone",
	"ap_records_existed_for_this_warehouse_receive_(apnum:_": "AP records existed for this warehouse receive (APNum: ",
	"ap_statistics": "AP Statistics",
	"app_email": "App Email",
	"app_email_phone": "App Email or Phone",
	"approval_confirm": "Confirm",
	"approval_pending": "Pending",
	"approve": "Approve",
	"approve_pending": "Approve Pending",
	"approve_status": "Approval Status",
	"approving": "Approving",
	"ar_aged_report": "AR Aged Report",
	"ar_aged_report_detail": "AR Aged Report Detail",
	"ar_customer_payment": "AR Customer Payment",
	"ar_date": "AR Date",
	"ar_num": "AR No.",
	"ar_slashsign_ap": "AR / AP",
	"ar_statement": "AR Statement (Unpaid Inv.)",
	"ar_statement2": "AR & Payment Statement (All Inv.)",
	"ar_statistics": "AR Statistics",
	"arrival": "Arrival",
	"arrival_status": "Arrival Status",
	"asia_supermarket": "Asian Supermarket",
	"assing_batch": "ASSING BATCH",
	"assoc_company": "Associated Company",
	"attachment": "Attachment",
	"attachment_upload": "Attachment Upload",
	"auto_apply": "Auto Apply",
	"auto_fill": "Auto Fill",
	"auto_load": "Auto Load",
	"auto_print_button": "Auto Print",
	"auto_putaway": "Auto Putaway",
	"available": "Available",
	"available_bins": "Available Bins",
	"available_qty": "Available Qty",
	"available_wt": "Available Wt",
	"avg_cost": "Avg. Cost",
	"avg_cost_price": "Avg. Cost$",
	"avg_in_stock_dollarsign": " Avg. In Stock $",
	"avg_markup_percentsign": "Avg. Markup %",
	"avg_sale_dollarsign": "Avg. Sale $",
	"avg_wt": "Avg Wt",
	"b2b_b2c": "B2B/B2C",
	"back": "Back",
	"back_no": "Backorder No",
	"balance": "Balance",
	"bank_account": "Bank Account",
	"barcode": "Barcode",
	"barcode_8_11": "8x11",
	"barcode_export": "Barcode Export",
	"barcode_half": "8x11 half",
	"barcode_poundsign": "Barcode #",
	"basic_info": "Basic Info",
	"batch_no": "Batch No.",
	"batch_no_po_no": "Batch No. (PO No.)",
	"batch_num": "Batch No.",
	"belk": "Belk",
	"big_prd": "Big Prd",
	"bill_date": "Bill Date",
	"billing_address": "Billing Address",
	"billing_contact": "Billing Contact",
	"billing_details": "Billing Details",
	"billing_information": "Billing Information",
	"bin": "Bin",
	"bin_amount": "Bin Amount",
	"bin_detail_view": "Bin Detail View",
	"bin_name": "Bin Name",
	"bin_range": "Bin Range",
	"bins_available": "Bins Available",
	"bol": "BOL",
	"bol_inventory": "BOL Inventory",
	"bol_list": "BOL List",
	"bol_num": "BOL Num",
	"bom": "BOM",
	"brand": "Brand",
	"broker/trader/import": "Broker/Trader/Import",
	"business_phone": "Business Phone",
	"business_type": "Business Type",
	"button": "Button",
	"buy": "Buy",
	"buy_a_get_b": "Buy A Get B",
	"by_3_days": "By 3 Days",
	"by_po": "By PO",
	"by_product": "By Product",
	"by_quantity": "By Quantity",
	"by_quantity_discount": "By Quantity (Discount)",
	"by_quantity_product": "By Quantity (Product)",
	"by_quantity_product_mix": "By Quantity(Mix Products)",
	"by_total_price": "By Total Price",
	"by_unit": "By Unit",
	"by_week": "By Week",
	"by_weight": "By Weight",
	"c_c": "C/C",
	"c_invoice": "C-Invoice",
	"cancel": "Cancel",
	"cancel_return": "Cancel Return",
	"canceled": "Canceled",
	"cancelled": "Cancelled",
	"carrier": "Carrier",
	"carrier_code": "Carrier Code",
	"carry_type": "Carry Type",
	"carry_type_shipping_method": "Carry Type Shipping Method",
	"case": "Case",
	"case (large prod)": "Case (Large Prod)",
	"case_dimension": "Case Dim.",
	"case_qty": "Case Qty",
	"cash_carrier": "Cash Carrier",
	"cash_dollarsign": "Cash $",
	"category": "Category",
	"category_1": "Category 1",
	"category_2": "Category 2",
	"category_2_b2b": "Category 2 B2B",
	"category_2_B2B_product_list": "CATEGORY 2 B2B PRODUCT LIST",
	"category_2_b2c": "Category 2 B2C",
	"category_2_login": "Category 2 Login",
	"category_2_product_list": "CATEGORY 2 PRODUCT LIST",
	"category_analysis": "Category Analysis",
	"category_description": "Category Description",
	"category_detail": "Category Detail",
	"category_display_info": "Category Display Info",
	"category_hidden": "Hidden Categories",
	"category_info_edit": "Edit Category Info",
	"category_meta_info": "Category Meta Info",
	"category_name": "Category Name",
	"category_name_permission": "Category Name",
	"category_num": "Categ. No.",
	"category_visible": "Visible Categories",
	"CBM": "CBM",
	"cc15": "1.5%",
	"cc_hold_until": "CC Hold Until",
	"close_batches": "Close Batches",
	"ch": "CH",
	"change_carrier_info": "Carrier Info",
	"change_delivery_fee": "Change Delivery Fee",
	"change_discount_rates": "Change Discount Rates",
	"change_employee_note": "Change Employee Note",
	"change_payment_method": "Payment Method",
	"change_pull_sheet": "Pull Sheet Assign Amount",
	"change_ship_weight": "Change Shipping Weight",
	"change_weight_button": "Change Weight",
	"charged": "Charged",
	"check": "Check",
	"check_dollarsign": "Check $",
	"check_num": "Check No.",
	"chi_name": "CHI Name",
	"chinese": "Chinese",
	"choose_batches": "Choose Batches",
	"chowbus": "Chowbus",
	"chowbus_import": "Chowbus Import",
	"cif": "CIF",
	"city": "City",
	"city_report": "City Report",
	"class_no": "Class No.",
	"clear": "Clear",
	"clear_all_values": "Clear All Values",
	"client": "Client/Cust",
	"close": "Close",
	"cmpy_stock": "Stock(Co)",
	"COD": "COD",
	"code": "Code",
	"color": "Color",
	"commit_qty": "Commit QTY(CPO)",
	"commercial_invoice": "Commercial Invoice",
	"company": "Company",
	"complete": "Complete",
	"complete_return": "Complete Return",
	"complete_this_sheet": "Complete This Sheet",
	"completed": "Completed",
	"concession_qty": "Concession Qty",
	"concession_qty_new": "Concession Qty",
	"confirm": "Confirm",
	"confirm_action": "Confirm Action",
	"confirm_add": "Confirm Add",
	"confirm_approve": "Confirm",
	"confirm_create": "Confirm Create",
	"confirm_delete": "Confirm Delete",
	"confirm_group_change": "Confirm Group Change",
	"confirm_new_password": "Confirm New Password",
	"confirm_password": "Confirm Password",
	"confirm_print_tracking": "Confirm Print Label",
	"confirm_refresh": "Confirm reload and refresh system?",
	"confirm_review": "Confirm",
	"confirm_sync_to_mes": "Confirm Sync To MES?",
	"confirm_void": "Confirm Void",
	"confirmation": "Confirmation",
	"confirmNcontinue": "Confirm & Continue",
	"contact": "Contact",
	"contact_information": "Contact Information",
	"contact_person": "Contact Person",
	"contact_poundsign": "Contact #",
	"container_no": "Container No.",
	"container_num": "Container No:",
	"content_management": "Content Management",
	"continue_product": "Continue",
	"convert": "Convert",
	"convert_date": "Convert Date",
	"convert_item_price": "Convert Item Price",
	"convert_prod_qty": "Convert Prod Qty",
	"convert_product_qty": "Convert Product Qty",
	"convert_quantity": "Convert Quantity",
	"convert_target_quantity": "Convert target Quantity",
	"convert_type": "Convert Type",
	"convert_user": "Convert User",
	"convertable_product": "Convertable Product",
	"copy_success": "Copy Success",
	"cost": "Cost",
	"cost_dollarsign": "Cost $",
	"cost_pri": "Cost$",
	"costco": "Costco",
	"costs_details": "Costs Details",
	"county": "County",
	"cpo_num": "CPO Num",
	"create": "Create",
	"create_a_new_agent": "Create a New Agent",
	"create_a_new_category": "",
	"create_a_new_customer": "Create A New Customer",
	"create_a_new_favorite": "Create A New Favorite",
	"create_a_new_product": "Create A New Product",
	"create_a_new_purchase": "Create a New Purchase",
	"create_a_new_purchase_order": "Create a New Purchase Order",
	"create_a_new_purchase_quote": "Create a New Purchase Quote",
	"create_a_new_purchase_return": "Create a New Purchase Return",
	"create_a_new_purchase_schedule": "Create a New Purchase Schedule",
	"create_a_new_purchase_template": "Create a New Purchase Template",
	"create_a_new_sales_order": "",
	"create_a_new_user": "",
	"create_a_new_vendor": "Create a New Vendor",
	"create_a_purchase_quote": "Create a Purchase Quote",
	"create_a_purchase_schedule": "Create a Purchase Schedule",
	"create_account": "Create Account",
	"create_and_duplicate": "Create and Duplicate",
	"create_ap": "Create AP",
	"create_ar": "Create AR",
	"create_bin": "",
	"create_customer_return": "Create Customer Return",
	"create_date": "Create Date",
	"create_excel": "Create Excel",
	"create_inventory_adjustment_sheet": "Create Inventory Adjustment Sheet",
	"create_inventory_convert_sheet": "Create Inventory Convert Sheet",
	"create_inventory_relocation_sheet": "Create Inventory Relocation Sheet",
	"create_inventory_repackage_sheet": "Create Inventory Repackage Sheet",
	"create_mfg": "Create MFG",
	"create_mfg_success": "Create MFG Success",
	"create_new_po": "Create New Purchase Order",
	"create_new_purchase_order": "Create New Purchase Order",
	"create_new_sales_order": "Create New Sales Order",
	"create_payment": "Create Payment",
	"create_picking": "Create Picking List",
	"create_pr": "Create PR",
	"create_pr_success": "Create PR Success",
	"create_product": "Create Product",
	"create_promotion": "Create Promotion",
	"create_purchase_order": "Create Purchase Order",
	"create_purchase_quote": "Create Purchase Quote",
	"create_put_away": "",
	"create_receiving": "Create Receiving",
	"create_role": "Create Role",
	"create_sales_order": "Create Sales Order",
	"create_sales_return": "Create Sales Return",
	"create_so": "Create SO",
	"create_task": "Create Task",
	"create_time": "Create Time",
	"create_user": "Create User",
	"create_warehouse": "Create Warehouse",
	"create_zone": "",
	"created": "Created",
	"created_by": "Created By",
	"created_time": "Created Time",
	"credit": "Credit",
	"credit_card": "Credit Card",
	"Credit_card": "Credit Card:",
	"credit_card_dollarsign": "Credit Card $",
	"credit_limit": "Credit Limit",
	"credit_limit_payment_term_warning": "Customer has exceed his Credit Limit and/or Payment Term Limit. In order to create SO, please verify your identity with passcode",
	"credit_line": "Credit Line",
	"credit_note": "Customer Credit Notes",
	"credit_reason": "Credit Reason",
	"credit_status": "Credit Status",
	"CRV": "CRV",
	"crv": "CRV",
	"cso_no": "CSO No.",
	"currency_management": "Currency Management",
	"current_bin": "Current Bin",
	"current_inventory": "Current Inventory",
	"current_order_amount": "Current Order Amount",
	"current_order_total": "Current Order Total",
	"current_quantity": "Current Quantity",
	"current_target_inventory": "Current Target Inventory",
	"current_zone": "Current Zone",
	"cust_id": "Cust ID",
	"cust_name": "Cust. Name",
	"cust_name.": "Cust Name",
	"cust_name_new": "Cust Name",
	"cust_no": "Cust No.",
	"cust_note": "Cust Note",
	"cust_phone": "Cust Phone",
	"cust_po": "Cust PO.",
	"custom": "Custom",
	"customer": "Customer",
	"Customer_Address": "Customer Address",
	"customer_credit": "Customer Credit",
	"customer_credit_report": "Customer Credit Report",
	"customer_description": "",
	"customer_details": "Customer Details",
	"customer_discount": "Discount(%OFF)",
	"Customer_Email": "Customer Email Address",
	"customer_group": "Customer Group",
	"customer_id": "Customer ID",
	"customer_information": "Customer Information",
	"customer_inventory": "Customer Inventory",
	"customer_link": "Link Customers",
	"customer_log": "Customer Log",
	"customer_management": "",
	"Customer_Mobile": "Customer Mobile",
	"customer_name": "Customer Name",
	"Customer_Name": "Customer Name",
	"customer_name_colonsign": "Customer Name:",
	"customer_no": "Customer No.",
	"customer_note": "Customer Note",
	"customer_num": "Customer Num",
	"customer_num_colonsign": "Customer No.:",
	"customer_order_schedule": "Customer Order Schedule",
	"customer_price_level": "Customer Price Level",
	"customer_return": "Customer Return",
	"customer_rma": "Customer RMA",
	"customer_sales_history": "Customer Sales History",
	"customer_statement": "Customer Statement",
	"customer_type": "Customer Type",
	"customers": "",
	"dashboard": "",
	"dashboard_v1": "",
	"dashboard_v2": "",
	"dashboard_v3": "",
	"date": "Date",
	"date_filter": "Date filter",
	"date_range": "Date Range",
	"dates": "Dates",
	"davis_po": "Davis PO",
	"days": "Days",
	"days_all": "All",
	"dead": "Dead",
	"decimal": "Decimal",
	"default": "Default",
	"default_address": "Default Address",
	"default_bin": "Default Bin",
	"default_location": "Default Location",
	"default_location_colonsign": "Default Location:",
	"default_purchaser": "Default Purchaser",
	"default_sales": "Default Sales",
	"default_warehouse": "Default Warehouse",
	"default_warehouse_bin": "Default Warehouse Bin",
	"default_warehouse_zone": "Default Warehouse Zone",
	"default_zone": "",
	"del": "DEL",
	"del_end_time": "Dely End Time",
	"del_start_time": "Dely start time",
	"delayed": "Delayed",
	"delete": "Delete",
	"Delete Zone?": "Delete Zone?",
	"delete_double": "Delete (double-click)",
	"delete_file": "Delete File",
	"delete_product": "Delete Product",
	"delete_purchase_order": "Delete Purchase Order",
	"delete_purchase_template": "Delete Purchase Template",
	"delete_successful": "Delete Successful",
	"delete_user": "Delete User",
	"deleted": "Deleted",
	"deliver_date": "Deliver Date",
	"deliver_end_time": "Deliver End Time",
	"deliver_start_time": "Deliver Start Time",
	"deliver_warehouse": "Deliver Warehouse",
	"delivered": "Delivered",
	"delivery": "Delivery",
	"delivery_pickup": "Delivery/Pickup",
	"delivery_tracking_num": "Delivery Tracking Number",
	"delivery_warehouse": "Delivery Warehouse",
	"desc": "Desc",
	"description": "Description",
	"detail": "Detail",
	"detailed_excel": "Detailed Excel",
	"detailed_information": "Detailed Information",
	"details": "Details",
	"details_&_convert": "",
	"details_&_repackage": "",
	"details_and_convert": "Details&Convert",
	"details_and_repackage": "Details & Repackage",
	"difference": "Diff",
	"dim_w_l": "Dim (W x L)",
	"dimension": "Dimension",
	"disable": "Disable",
	"disabled": "",
	"disc": "Disc",
	"discard_changes": "Discard Changes",
	"discontinue": "Discontinued",
	"discount": "Discount",
	"discount_$": "Discount $",
	"discount_description": "Discount Description",
	"discount_p": "Disc(%)",
	"discount_rate_%": "Discount Rate %",
	"dispatch": "Dispatch",
	"dispatch_date": "Dispatch Date",
	"Dispatch_Description": "Shipping Description",
	"dispatch_location": "Dispatch Location",
	"Dispatch_Logistics_Company": "Shipping Company",
	"dispatch_rma": "Dispatch RMA",
	"Dispatch_Tracking_Number": "Tracking Number",
	"display": "Display",
	"distance": "Distance",
	"dl_num": "DL Num",
	"document_date": "Documented",
	"documented": "Documented",
	"done": "Done",
	"dop": "DOP",
	"complete_percent": "Complete %",
	"download": "Download",
	"download_ns": "Purchase BOL$",
	"download_PDF": "Download PDF",
	"download_po": "Download PO",
	"download_so": "Download SO",
	"download_sq": "Download SQ",
	"draft": "Draft",
	"return_total_$": "Total Return $",
	"reset_password_all": "Reset All Passwords",
	"driver": "Driver",
	"driver_license": "Driver License Number",
	"dropship": "Dropship",
	"dropship_po_detail": "Dropship",
	"dropship_so_detail": "Dropship",
	"ds": "DS",
	"duplicate": "Duplicate",
	"duplicate_customer": "Duplicate Customer",
	"duplicate_product": "Duplicate Product Found",
	"duplicate_product_promotion": "This product is being used in another promotion. Do you wish to add anyway?",
	"duplicate_so": "Duplicate SO",
	"e_fax": "E Fax",
	"ebt_card_dollarsign": "EBT Card $",
	"ecom_picking_list_location": "ECOM Picking List Location",
	"edit": "Edit",
	"edit_agent": "",
	"edit_bin": "",
	"edit_category": "Edit Category",
	"edit_customer": "Edit Customer",
	"edit_customer_confirm": "This action will void the current invoice and copy current invoice information to a new invoice. Continue?",
	"edit_customers": "Edit Customers",
	"edit_display_category": "Edit Display Categories",
	"edit_display_category_warning": "Must Create Product Before Editing",
	"edit_driver": "Edit Driver",
	"edit_esl": "Edit ESL",
	"edit_group": "",
	"edit_groups": "",
	"edit_invoice": "Edit Invoice",
	"edit_password": "Edit Password",
	"edit_payment": "Edit Payment",
	"edit_payment_term": "Edit Payment Term",
	"edit_product": "Edit Product",
	"edit_product_meta": "Edit Product Meta Info",
	"edit_purchase": "Edit Purchase",
	"edit_purchase_order": "Edit Purchase Order",
	"edit_purchase_quote": "Edit Purchase Quote",
	"edit_purchase_return": "Edit Purchase Return",
	"edit_purchase_schedule": "Edit Purchase Schedule",
	"edit_purchase_template": "Edit Purchase Template",
	"edit_put_away": "Edit Put Away",
	"edit_released_si": "",
	"edit_route": "",
	"edit_routes": "Edit Routes",
	"edit_sales_invoice": "",
	"Edit_sales_order": "",
	"edit_sales_order": "",
	"edit_so": "Edit SO",
	"edit_user": "",
	"edit_username": "Edit Username",
	"edit_vendor": "Edit Vendor",
	"edit_warehouse": "Edit Warehouse",
	"effect": "Effect",
	"effect_date": "Effect Date",
	"ein": "EIN",
	"email": "Email",
	"email_address": "Email Address",
	"email_colonsign": "Email:",
	"email_detail_excel": "Email Detailed Excel",
	"email_po": "Email PO",
	"email_SI": "Email SI",
	"email_so": "Email SO",
	"email_statement": "Email Statement",
	"emp_note": "Emp Note",
	"employee_note": "Employee Note",
	"en": "EN",
	"enabled": "Enabled",
	"end": "End",
	"end_date": "End Date",
	"eng_name": "ENG Name",
	"english": "",
	"enter_email_of_driver": "Enter the email of your driver",
	"error": "Error",
	"ESL": "ESL",
	"esl_code": "ESL Code",
	"esl_template": "ESL Template",
	"est_date": "Est Date",
	"est_delivery": "Est Delivery",
	"est_receive_date": "Est Receive Date",
	"est_sale_price": "Est Sale Price",
	"est_tax": "Est. Tax",
	"et_sale_total": "Est Sale Total",
	"eta_date": "ETA Date",
	"ETD_date": "ETD Date",
	"etd_date": "ETD Date",
	"eu_size": "EU Size",
	"excel": "Excel",
	"excel_by_vendors": "Excel By Venders",
	"excel_lines": "Excel Lines",
	"excel_qb": "Excel For QB",
	"excel_with_details": "Excel with Details",
	"existing_detail": "Add items To The Existing Order",
	"exit": "Exit",
	"exp_delivery_date": "Exp Delivery Date",
	"expire_date": "Expire Date",
	"expire_datetime": "Expire Date (MM-DD-YYYY)",
	"expired": "EXPIRED",
	"expired_date": "Expired Date",
	"expired_inventories": "Expired Inventories",
	"expired_warning": "Expired Warning",
	"expiring": "Expiring",
	"export": "Export",
	"export_date": "Expired Date",
	"export_inventories": "Export Inventories",
	"export_line_detail": "Export Line Detail",
	"export_template": "Export template",
	"export_to_excel": "Export to Excel",
	"ez": "EZ",
	"faq": "FAQ",
	"favorite_items": "",
	"favorite_list": "",
	"favorite_product_list": "Favorite Product List",
	"favorites_list": "Favorites List",
	"fax": "Fax",
	"fax_colonsign": "Fax:",
	"fba_route": "FBA Route",
	"fees_discount": "Fees & Discount",
	"field": "Field",
	"file": "File",
	"file_name": "File Name",
	"file_no": "File No.",
	"fill_with_latest_value": "Fill With Last Values",
	"filter": "Filter",
	"final": "Final",
	"final_dollar": "Final $",
	"final_dollarsign": "Final $",
	"final_dollarsign2": "PO Final $",
	"final_dollarsign3": "Received Final $",
	"final_price": "Final Price",
	"final_weight": "",
	"final_wt": "Final Wt.",
	"finalize": "Finalize",
	"finalize_invoice": "Finalize Invoice",
	"finalize_selected_receiving_vak": "Do you want to Finalize the receiving to add the inventory?",
	"finalize_si": "",
	"finalized": "Finalized",
	"finish": "Finish",
	"Finish_Shipping": "Finish Shipping ",
	"first_name": "First Name",
	"fob": "FOB",
	"fob_point": "FOB Point",
	"fob_unit_price": "Fob Unit Price",
	"food_stamp": "EBT/Food Stamp",
	"forenoon": "forenoon",
	"free": "Free",
	"frequent_products": "Frequent Products",
	"Fri": "Fri",
	"fri_route": "Fri Route",
	"fri_stop": "Fri Stop",
	"from": "From",
	"from_bin": "",
	"front_color": "Front Color",
	"full_list_table_sales_invoice": "",
	"full_list_table_sales_order": "Full List Table | Sales Order",
	"general": "General",
	"general_dashboard": "General Dashboard",
	"general_info": "General Information",
	"general_information": "General Information",
	"general_ledger": "General Ledger",
	"general_management": "General Management",
	"general_no": "General No.",
	"general_product_convert": "General | Product Convert",
	"general_product_repackage": "General|Product Repackage",
	"general_report": "General Report",
	"generate_all_barcode": "Generate All Barcode",
	"generate_all_zone_barcode": "All Zone Barcode",
	"generate_barcode": "Generate Barcode",
	"generating": "Generating....",
	"get": "Get",
	"ggi_batch": "GGI-Batch",
	"gift_quantity": "Product Gift Quantity",
	"gift_quantity_column": "Gift Quantity",
	"GL": "GL",
	"gl_form": "GL Form",
	"gl_list": "GL List",
	"gl_number": "GL Number",
	"good": "Good",
	"Good_Credit": "Good Credit",
	"grand_total": "Grand Total",
	"gross_weight": "Gross Wt",
	"group": "Group",
	"group_buy": "Group Buy",
	"group_list": "Group List",
	"group_name": "Group Name",
	"group_name_permission": "Group Name",
	"group_name_role": "Group Name",
	"group_sku_num_is_required": "Group SKU is required",
	"group_wholesale": "Wholesale",
	"groups": "Groups",
	"groups_management": "Groups Management",
	"gtin": "GTIN",
	"gv_rewards": "GV Rewards",
	"handle_pending": "Pending",
	"handling": "Handling",
	"handling_cost": "Handling Cost",
	"hanger": "Hanger",
	"has_pod": "HAS POD",
	"hide": "Hide",
	"hmart_barcode": "HMart Code",
	"hold": "Hold",
	"ib_excel_template": "IB Template",
	"id": "ID",
	"idx": "IDX",
	"Image": "Image",
	"image_2": "Image #2",
	"image_size_limit": "Each file size cannot exceed 3mb.",
	"import": "Import",
	"import_so": "Import SO",
	"in_stock": "In Stock",
	"in_stock_colonsign": "In Stock:",
	"in_stock_inactive": "In Stock / Inactive",
	"inactive": "Inactive",
	"inbound": "Inbound",
	"inbound_area": "",
	"inbound_order": "Inbound Order",
	"inbound_orders": "Inbound Orders",
	"inbound_plt": "Inbound PLT",
	"inbound_products": "Inbound Products",
	"inbound_report": "Inbound Report",
	"incomplete": "Incomplete",
	"index": "INDEX",
	"index_no": "Index No.",
	"insert_new_product_in_favorite_list": "",
	"instock": "In Stock",
	"instock_co": "Instock(CO)",
	"insurance": "Insurance",
	"insure_amount": "Insure Amount",
	"internal_barcode": "Internal Barcode",
	"inv": "Inv.",
	"inv_cost": "Inv. Cost",
	"inv_modifier": "Inv Modifier",
	"inv_qty_vak": "INV QTY",
	"inv_wt_vak": "INV WT",
	"inventories": "Inventories",
	"inventory": "Inventory",
	"inventory_adjust_sheet_warehouse_loc": "Inventory Adjustment Sheet | Warehouse Location",
	"inventory_adjust_warehouse_loc": "Inventory Adjustment | Warehouse Location",
	"inventory_adjustment": "Inventory Adjustment",
	"inventory_adjustment_sheet": "Inventory Adjustment Sheet",
	"inventory_adjustments": "Inventory Adjustments",
	"inventory_convert": "Inventory Convert",
	"inventory_convert_sheet": "Inventory Convert Sheet",
	"inventory_convert_sheet_warehouse_location": "Inventory Convert Sheet | Warehouse Location",
	"inventory_convert_warehouse_location": "Inventory Convert | Warehouse Location",
	"inventory_converts": "Inventory Converts",
	"inventory_detail": "Inventory Detail",
	"inventory_details": "Inventory Details",
	"inventory_expired_passed_due": "INVENTORY EXPIRED/PASSED DUE",
	"inventory_information": "Inventory Information",
	"inventory_number": "",
	"inventory_price": "Inventory Price",
	"inventory_receive": "Inventory Receive",
	"inventory_receive_details": "Inventory Receive Details",
	"inventory_receive_information": "Inventory Receive Information",
	"inventory_receive_sheet": "Inventory Receive Sheet",
	"inventory_relocation": "Inventory Relocation",
	"inventory_relocation_sheet": "Inventory Relocation Sheet",
	"inventory_relocation_sheet_warehouse_location": "Inventory Relocation Sheet|Warehouse Location",
	"inventory_relocation_warehouse_location": "Inventory Relocation | Warehouse Location",
	"inventory_relocations": "Inventory Relocations",
	"inventory_repackage": "Inventory Repackage",
	"inventory_repackage_sheet": "Inventory Repackage Sheet",
	"inventory_repackage_warehouse_loc": "Inventory Repackage|Warehouse Location",
	"inventory_scrap": "Inventory Scrap",
	"inventory_scrap_sheet": "Inventory Scrap Sheet",
	"inventory_scrap_sheet_warehouse_location": "Inventory Scrap Sheet|Warehouse Location",
	"inventory_scrap_warehouse_location": "Inventory Scrap|Warehouse Location",
	"inventory_transfer": "Inventory Transfer",
	"invite": "Invite",
	"invoice": "",
	"invoice_amount": "Invoice Amount",
	"invoice_date": "",
	"invoice_date_colonsign": "Invoice Date:",
	"invoice_dollarsign": "Invoice $",
	"invoice_final_dollarsign": "Invoice Final $",
	"invoice_no": "Invoice No.",
	"invoice_no_colonsign": "Invoice No.:",
	"invoice_not_received": "INVOICE NOT RECEIVED",
	"invoice_or_serial_no": "Invoice / Serial No. search",
	"invoice_or_so_no": "Invoice / SO No. search",
	"invoice_total": "",
	"invoice_type": "Invoice Type",
	"invoice_vendor": "Vendor Invoice",
	"invoiced": "Invoiced",
	"invoiced_cost": "INVOICED / COST",
	"invoices_not_finalized": "Invoices Not Finalized",
	"is_at_inbound_area": "",
	"is_at_outbound_area": "",
	"is_dropship": "Is Dropship",
	"is_enabled": "Enabled*",
	"is_mes": "From MES",
	"is_no_reduce": "No Stock Deduction",
	"is_public": "Is Public",
	"is_restock": "Is Restock",
	"is_retailer": "Is Retailer",
	"is_spare": "Is Spare",
	"Is_Urgent": "Is Urgent?",
	"Is_Warranty": "Has Warranty?",
	"isa_num": "ISA Num",
	"issue_credit": "Issue Credit",
	"issue_return": "Issue Return",
	"item_count": "Item Count",
	"item_dimension": "Item Dim",
	"Item_is_out_of_stock": "Item is out of Stock",
	"item_name": "",
	"item_no": "Item No.",
	"key": "Key",
	"kohlsb2b": "Kohl's B2B",
	"lang": "Lang",
	"large_label_mac": "L-MAC",
	"large_label_win": "L-WIN",
	"last_cost": "Last Cost",
	"last_dollarsign": "Last $",
	"last_modified_by": "Last Modified By",
	"last_month": "Last Month",
	"last_name": "Last Name",
	"last_return_date": "Last RTN Date",
	"lb": "lb",
	"level": "Level",
	"level_1": "Level 1",
	"level_2": "Level 2",
	"level_3": "Level 3",
	"level_4": "Level 4",
	"level_5": "Level 5",
	"levels": "Levels",
	"LF_Date": "LF Date",
	"lg": "Lg",
	"limit": "Display Limit",
	"limit_qty_order": "Limited Qty/Order",
	"limit_qty_order_desc": "(Zero means no restrictions)",
	"link_existing_prod": "Link Existing Prod",
	"linked_so_no": "",
	"list_of_adjustment_lines": "List of Inventory Adjustment Lines",
	"list_of_inventory_convert_lines": "List of Inventory Convert Lines",
	"list_of_inventory_relocation_lines": "List of Inventory Relocation Lines",
	"list_of_inventory_repackage_lines": "",
	"list_of_inventory_scrap_lines": "List of Inventory Scrap Lines",
	"list_of_repackage_lines": "List of Inventory Repackage Lines",
	"load_id": "Load ID",
	"loaded_qty": "Loaded Qty",
	"loaded_quantity": "Loaded Quantity",
	"local_ship": "Local Ship",
	"location": "Location",
	"location_bin": "Bin",
	"login": "",
	"login_in": "Login",
	"logo": "Logo",
	"logout": "",
	"long_codes": "Long Codes",
	"lot_no": "Lot No.",
	"low_stock": "Low Stock",
	"low_stock_inventories": "Low Stock Inventories",
	"low_stock_inventory": "Low Stock Inventory",
	"lowest_amount": "Lowest Amount",
	"lowest_amt": "",
	"lowest_sale_dollarsign": "Lowest Sale $",
	"lowest_sales": "Lowest Sales",
	"ltl_carrier": "LTL Carrier",
	"lv1": "Lv1",
	"lv2": "Lv2",
	"lv3": "Lv3",
	"lv4": "Lv4",
	"lv5": "Lv5",
	"mailing": "Mailing",
	"mailing_address": "Mailing Address",
	"mailing_contact": "Mailing Contact",
	"mailing_contact_information": "Mailing Contact Information",
	"mailing_details": "Mailing Details",
	"mailing_information": "Mailing Information",
	"main_sku": "Main SKU",
	"manage_active_users": "Manage Active Users",
	"manage_customers": "Manage Customers",
	"manage_doc": "Manage DOC",
	"manage_pod": "Manage POD",
	"manage_promotions": "Manage Promotions",
	"manual_print_button": "Manual Print",
	"march": "March",
	"margin": "Margin",
	"margin$": "Margin %",
	"margin_%": "Margin (%)",
	"marketing": "Marketing",
	"match": "Match",
	"max": "",
	"max_limit": "Max Limit",
	"max_limit_colonsign": "Max Limit:",
	"max_stock_range": "Max Stock Range",
	"measure": "Measure",
	"measure_unit": "",
	"member_card": "Member Card",
	"memo_no": "Memo No.",
	"memo_poundsign": "Memo #",
	"merchant_report": "Merchant Report",
	"merchant_summary": "Merchant Summary",
	"merge_so": "Merge SO",
	"meta_description": "Description",
	"meta_info": "Meta Info",
	"meta_keywords": "Keywords",
	"meta_title": "Title",
	"method": "Method",
	"mfg_management": "MFG Management",
	"mfg_num": "MFG No.",
	"mfg_order": "MFG No.",
	"mfg_orders": "MFG Orders",
	"mfg_review": "Review",
	"mfg_set_approve": "Set Approve",
	"mfg_set_recheck": "Set Recheck",
	"mfg_set_review": "Set Review",
	"mfr_no": "MFR No",
	"middle_name": "Middle Name",
	"min": "",
	"min_limit": "Min Limit",
	"min_limit_colonsign": "Min Limit:",
	"min_purchase_amount": "Min Purchase Amount",
	"min_qty_vendor": "Min Qty",
	"min_stock_range": "Min Stock range",
	"misc": "Misc",
	"misc_cost": "",
	"misc_cost_detail": "",
	"misc_cost_details": "Misc Cost Details",
	"misc_detail": "Misc Detail",
	"misc_dollarsign": "Misc $",
	"misc_fee": "Misc Fee",
	"missing_skus": "Missing SKUs",
	"mix_product": "Mix Product",
	"mix_setting": "Mix Setting",
	"mm": "MM",
	"mm_type": "MM Type",
	"mm_unit": "MM Unit",
	"mobile": "Mobile",
	"mobile_customer_statement": "Mobile Customer Statement",
	"mobile_description_box": "Mobile Description Box",
	"mobile_dollarsign": "Mobile $",
	"mobile_management": "Mobile Management",
	"mobile_sale": "Mobile Sale",
	"mobile_sales_order": "Mobile Sales Order",
	"mobile_username": "Mobile Username",
	"mobile_users": "Mobile Users",
	"modified": "Modified",
	"modified_by": "Modified By",
	"modified_on": "Modified On",
	"modified_time": "Modified Time",
	"modifier": "Modifier",
	"modify": "Modify",
	"modify_inventory": "Modify Inventory",
	"modify_username": "Modify Username",
	"Mon": "Mon",
	"mon_route": "Mon Route",
	"mon_stop": "Mon Stop",
	"month": "Month",
	"Monthly": "Monthly",
	"more_info": "More Info",
	"move_all": "Move All",
	"move_off": "Move Off",
	"move_off_from_list": "Move off from list",
	"move_off_from_products_list": "Move off From Products List",
	"move_off_products_list": "Move Off Products List",
	"move_selected": "Move Selected",
	"move_to": "Move To",
	"move_to_list": "move to list",
	"move_to_po": "Move To PO",
	"move_to_product_list": "",
	"move_to_products_list": "",
	"move_to_so": "Move to SO",
	"move_to_so_list": "",
	"mr_orders": "MR Orders",
	"msg_add_duplicate_item": "You are adding a duplicate item",
	"msg_agree_terms": "I agree with terms.",
	"msg_ask_for_manager_login": "Type in manager's username and password",
	"msg_ask_if_confirm_to_approve": "Pls Confirm or Reject the order request upon your approval",
	"msg_ask_if_confirm_to_review": "Pls Confirm or Reject the order request upon your review",
	"msg_ask_if_confirm_to_set_approve": "Do you want to set the order for approval?",
	"msg_ask_if_confirm_to_set_review": "Do you want to set the order for review?",
	"msg_ask_if_stay_on_current_page": "Do you want to stay on the current page?",
	"msg_assign_customer": "Assign current order to customer:",
	"msg_confirm_add_customer_to_group": "Adding this customer to this group will remove them from their previous group. Are you sure?",
	"msg_confirm_change_group_without_save_products": "Are you sure you want to change groups without saving your products?",
	"msg_confirm_customer": "Confirm set customer?",
	"msg_confirm_delete": "Are you sure you want to delete?",
	"msg_confirm_merge_pos": "Are you sure you want to merge these purchase orders?",
	"msg_confirm_pending": "Set Order To Pending Status?",
	"msg_confirm_po_convert_so": "Confirm Convert Purchase Order To Sales Order",
	"msg_confirm_print_tracking": "Order has existing Tracking Number. Continue to print label?",
	"msg_confirm_quote": "Confirm set Quotes to Sales Orders?",
	"msg_confirm_refund_order": "Are you sure you want to refund order?",
	"msg_confirm_reship": "Are you sure you want to reship order?",
	"msg_confirm_setso_quote": "Set Order To Quote Status?",
	"msg_convert_qty_cannot_exceed_current_qty": "Conversion quantity cannot be higher than current quantity",
	"msg_drag_drop_attachment": "Drop some files here, or click to select files to upload.",
	"msg_drop_upload_files": "Try dropping some files here, or click to select files to upload.",
	"msg_enter_scrap_amount_and_inventory_will_be_updated": "Enter the scrap amount below and the inventory will be updated accordingly",
	"msg_existing_purchase_order_for_customer": "An order has already been placed for this customer today, do you want to continue?",
	"msg_export_order_stats": "Exporting user stats could take up to 1 minute, please stay on the page",
	"msg_grand_total_equation": "* Grand Total = Total - Canceled",
	"msg_inventory_price_equation": "* Inventory Price = Avg Cost × Stock",
	"msg_item_already_in_sales_order": "This item is already in the sales order",
	"msg_large_prod": "Case (Large Prod)",
	"msg_mfg_approve_success": "Approve successfully",
	"msg_mfg_reject_approve_success": "Reject successfully",
	"msg_mfg_reject_success": "Reject successfully",
	"msg_mfg_review_ap_success": "Review successful, do you want to initiate a review?",
	"msg_mfg_review_success": "Review successfully",
	"msg_mfg_set_approve_success": "Set Approve successfully",
	"msg_mfg_set_review_success": "Set Review successfully",
	"msg_no_permission": "You don't have permission for this operation.",
	"msg_operation_saved": "Your operation has been saved",
	"msg_please_select_a_vendor": "Please Select a Vendor",
	"msg_po_to_so_dropship": "Confirm SO to PO (Davis)?",
	"msg_product_image_modal_desc": "* Please save your work before closing the window",
	"msg_products_loaded_click_save_to_complete": "All products are loaded. Press save to complete the order.",
	"msg_purchase_order_num_is": "The purchase order No. is",
	"msg_purchase_order_saved": "Your purchase order has been saved",
	"msg_purchase_quote_generated": "Your purchase quote is generated",
	"msg_purchase_quote_saved": "Your purchase quote has been saved",
	"msg_purchase_template_saved": "Your purchase template has been saved",
	"msg_received_total_equation": "* Total Received Final = Received - Canceled",
	"msg_relocation_qty_cannot_exceed_current_qty": "Relocation quantity cannot be higher than current quantity",
	"msg_repackage_qty_cannot_exceed_current_qty": "Repackage Quantity cannot be Higher than current Quantity",
	"msg_save_successfully": "Save successfully!",
	"msg_scrap_qty_cannot_exceed_current_qty": "Scrap Quantity cannot be Higher than current Quantity",
	"msg_select_a_group": "Select a Group",
	"msg_select_a_purchase_template": "Select a purchase template",
	"msg_select_an_inventory_as_target": "Select an inventory as target",
	"msg_select_an_inventory_to_adjust": "Select an inventory to adjust",
	"msg_select_an_inventory_to_convert": "Select an inventory to convert",
	"msg_select_an_inventory_to_relocate": "Select an inventory to relocate",
	"msg_select_an_inventory_to_repackage": "Select an inventory to repackage",
	"msg_select_an_item": "Select an item",
	"msg_select_customer": "Select customer",
	"msg_select_from_batch": "Select from batch",
	"msg_select_warehouse": "Select warehouse",
	"msg_select_warehouse_bin": "Select warehouse bin",
	"msg_select_warehouse_zone": "Select warehouse zone",
	"msg_show_action_log_from_last_90_days": "* Showing action logs from last 90 days",
	"msg_small_prod": "Piece (Small Prod)",
	"msg_total_orders_equation": "* Total Orders = Number of Orders - Canceled Orders",
	"total_item_sale_equation": "Total Item Sale $ = Total Invoice $ - Total Return $",
	"msg_total_qty_equation": " Total Qty = Total Qty - Total Cancelled Qty",
	"msg_total_receive_weight_equation": "Total Received WT = Total Weight - Total Cancelled Weight",
	"msg_total_received_qty_equation": "Total Received QTY = Total QTY - Total Cancelled QTY",
	"msg_total_weight_equation": " Total WT = Total Net Weight - Total Cancelled Net Weight",
	"MSO": "MSO",
	"msrp": "MSRP",
	"multilevel_marketing": "Multilevel Sales",
	"must be > 0": "must be > 0",
	"n1_prod_qty": "N1 Prod Qty",
	"n2_prod_qty": "N2 Prod Qty",
	"name": "Name",
	"Name_and_Description_fields_are_required": "Name and Description fields are required",
	"nationwide": "Nationwide",
	"nbt_rewards": "NBT Rewards",
	"need_to_signup": "Need To Sign Up?",
	"negative": "Negative",
	"net": "Net",
	"net_cost": "Net Cost",
	"net_receiving": "Net Receiving",
	"net_sales": "Net Sales",
	"net_weight": "Net Weight",
	"net_wt": "Net Wt",
	"new_arrival": "New Arrival",
	"new_inbound_order": "New Inbound Order",
	"new_outbound_order": "New Outbound Order",
	"new_password": "New Password",
	"new_purchase_order": "New Purchase Order",
	"new_purchase_quote": "New Purchase Quote",
	"new_purchase_template": "New Purchase Template",
	"new_quantity": "New Quantity",
	"new_receiving": "New Receiving",
	"new_sales_order": "New Sales Order",
	"new_sales_return": "New Sales Return",
	"new_scrap_record": "New Scrap Record",
	"new_series_no": "New Series No.",
	"new_so": "New SO",
	"new_username": "New Username",
	"new_value": "New Value",
	"new_vpn_template": "New VPN Template",
	"new_working_orders": "New Working Order",
	"next_execute_date": "Next Execute Date",
	"next_page": "Next >",
	"No": "No",
	"no": "No",
	"no_bin_range": "No Bin Range",
	"no_invoice": "",
	"no_mix_product": "No Mixed Products",
	"no_pickup": "",
	"no_price": "No Price",
	"no_return": "NO RETURN",
	"no_shipping_address": "No Shipping Address",
	"no_shipping_information": "No Shipping Information",
	"no_vendor": "",
	"non-asian_supermarket": "Non-Asian Supermarket",
	"non_fixed": "Non-Fixed",
	"non_food": "Non Food",
	"non_zero": "Non-Zero",
	"none": "None",
	"normal": "Normal",
	"not_shipped_quantity": "Unshipped",
	"not_yet_received": "Not Yet Received",
	"notation": "Notation",
	"notation_modal_next": "Next",
	"notation_modal_previous": "Previous",
	"note": "Note",
	"notes_for_pos": "Notes For POS",
	"notes_for_sales": "Notes For Sales",
	"num": "Num",
	"number": "Number",
	"number_of_card_transactions": "Number of Card Transactions",
	"number_of_checks": "Number of Checks",
	"nuorder_sync": "NuOrder Sync",
	"off_stock": "Out of Stock",
	"offrate": "Offrate",
	"ok": "OK",
	"ok_vendor": "OK",
	"old_value": "Old Value",
	"on_fleet": "Onfleet",
	"on_hold": "On Hold",
	"on_sale": "On Sale",
	"on_stock": "On Stock",
	"one_time": "One Time",
	"one_time_schedule": "One Time Schedule",
	"one_time_use": "One Time Use",
	"online_order": "Online Order",
	"oops": "Oops",
	"open": "Open",
	"Open": "Open",
	"open_draft": "Open Draft",
	"open_sales_orders": "Open Sales Orders",
	"Openbox_Description": "Openbox Description",
	"operate_time": "This action will take approx. 1 min.",
	"operation": "Action",
	"optional": "Optional",
	"optional_in_parentheses": "(Optional)",
	"optional_phone": "Alt/Fax Phone (optional)",
	"order": "Order",
	"order_amount": "Order Amount",
	"order_count_overview": "Orders Count Overview",
	"order_date": "Order Date",
	"order_details": "Order Details",
	"order_history": "",
	"order_image": "Order Image",
	"order_information": "Order Information",
	"order_num": "Order No.",
	"order_person": "Order Person",
	"order_qty": "Order Qty",
	"order_small_unit_dollarsign": "Order Small Unit",
	"order_stats": "Order Stats",
	"order_total": "Order Total",
	"order_total_dollarsign": "Order Total (USD)",
	"order_type": "Order Type",
	"order_unit": "Order Unit",
	"order_unit_dollarsign": "Order Unit (USD)",
	"order_wt": "ORDER WT",
	"ordered": "Ordered",
	"orders": "Orders",
	"orig_price": "Orig $",
	"Other": "Other",
	"out_of_stock": "Out of Stock",
	"out_of_stock_active": "Out of Stock / Active",
	"outbound": "",
	"Outbound Order": "Outbound Order",
	"outbound_area": "",
	"outbound_plt": "Outbound PLT",
	"outsourced_num": "Outsourced No.",
	"outstanding": "Outstanding",
	"outstanding_invoice": "",
	"outstanding_order": "",
	"over_stock": "Over Stock",
	"oversaleable": "Oversaleable",
	"oversea_ship": "Oversea Ship",
	"owner": "Owner",
	"package": "Package",
	"package_date": "Pack Date (MM-DD-YYYY)",
	"package_details": "Package Details",
	"package_dimension_shipping": "Pkg Dim Shipping",
	"package_size": "Pkg Size",
	"package_slashsign_weight": "Package / Weight",
	"package_type": "Pkg Type",
	"package_type_filter": "Pkg Type Filter",
	"package_weight_shipping": "Pkg Wt Shipping",
	"packageSize": "Package Size",
	"packaging_details": "Packaging",
	"packing": "Packing",
	"Packing": "Packing",
	"packing_mrfg": "Packing(MRFG)",
	"packing_mrfng": "Packing(MRFNG)",
	"packing_num": "Packing No.",
	"paid": "Paid",
	"paid_dollarsign": "Paid $",
	"pallet": "Pallet",
	"pallet_dimension": "Pallet Dim.",
	"partial": "Partial",
	"partial_ship": "Partial Ship",
	"partial_ship_qty": "Partial Qty",
	"partially_paid": "Partially Paid",
	"pass": "Pass",
	"passcode_confirm": "Please confirm your passcode",
	"passcode_confirm_text": "Please confirm passcode to proceed the previous action",
	"passed_due": "Passed Due",
	"password": "Password",
	"past_due": "Past Due",
	"payment": "Payment",
	"payment_amount": "payment amount",
	"payment_date": "Payment Date",
	"payment_detail": "Payment Detail",
	"payment_details": "Payment Details",
	"payment_info": "Payment Info",
	"payment_method": "Payment Method",
	"payment_open": "Open",
	"payment_status": "",
	"payment_summary": "Payment Summary",
	"payment_term": "",
	"payment_term_name": "",
	"payment_term_short": "Pay Term",
	"payment_terms_management": "Payment Terms Management",
	"payment_type": "Payment Type",
	"pc_box": "PC/Box",
	"pending": "Pending",
	"per_pallet": "Per Pallet",
	"per_pound": "Per-Pound",
	"percentsign_off": "% Off",
	"permission_name": "Permission Name",
	"phone": "Phone",
	"Phone_number": "Phone Number",
	"pick_up": "Pick up",
	"pickdrop": "Pickup/Dropoff",
	"pickdrop_info": "Pickup/Dropoff Information",
	"picked_qty": "Picked Qty",
	"picking_list": "Picking List",
	"picking_lt_num": "Picking No.",
	"pickup": "",
	"pickup_contact": "Pickup Contact",
	"pickup_poundsign": "Pickup #",
	"pickup_vendor_address": "Pickup Vendor Address",
	"pickup_warehouse": "Pickup Warehouse",
	"pickup_warehouse_name": "Pickup Warehouse Name",
	"piece": "Piece",
	"piece (small prod)": "Piece (Small Prod)",
	"pkg_dimension": "PKG Dim",
	"pkg_size_1": "Pkg Size 1",
	"pkg_size_2": "Pkg Size 2",
	"pkg_size_new": "(Pkg Size)",
	"pkg_type": "Pkg Type",
	"pl_report": "P&L Report",
	"place_new_order": "Place New Order",
	"placed": "Placed",
	"plain_statement": "Plain Statement",
	"platform": "Platform",
	"please_clarify_other": "Please Clarify Other",
	"please_enter_a_valid_email": "Please enter a valid email!",
	"please_enter_all_info": "Please enter all info!",
	"please_select_a_contact": "",
	"please_select_a_customer": "Please Select A Customer",
	"please_select_a_product": "Please Select a Product",
	"please_select_a_start_date_that_is_before_the_end_date": "Please select a start date that is before the end date.",
	"please_select_an_end_date_that_is_after_the_start_date": "Please select an end date that is after the start date.",
	"please_select_an_inventory": "Please select an inventory",
	"please_select_category": "Please Select Category",
	"please_select_group": "Please Select a Group",
	"please_select_inventory": "Please Select an Inventory",
	"pmt_date": "PMT Date",
	"pmt_status": "Payment Status",
	"po_convert": "PO Convert",
	"po_date": "PO Date",
	"po_details": "PO Details",
	"po_dollarsign": "PO $",
	"po_final": "PO Final",
	"po_final_dollarsign": "PO Final $",
	"po_info": "PO Info",
	"po_no": "PO No.",
	"po_num": "PO No.",
	"po_or_status": "Status",
	"po_pending": "Pending",
	"po_pending_status": "Pending",
	"po_placed": "Placed",
	"po_proxy": "Transit",
	"po_purchase_status": "PO Purchase Status",
	"po_qty": "PO QTY",
	"po_relocated": "Relocated",
	"po_scheduled_arrival": "PO Scheduled Arrival",
	"po_scheduled_arrival_up": "PO Scheduled Arrival",
	"po_scheduled_to_arrive": "PO Scheduled to Arrive",
	"po_status": "PO Status",
	"po_template": "PO Template",
	"po_total": "PO Total",
	"pod": "POD",
	"poor": "Poor",
	"pos": "POS",
	"pos_credit": "POS Credit",
	"pos_holds": "Pos Holds",
	"pos_holds_full_table": "POS Holds Full Table",
	"pos_management": "POS Management",
	"pos_no": "POS No.",
	"pos_order": "POS Order",
	"pos_order_credits": "POS Credit Full Table",
	"pos_order_full_table": "POS Order Full Table",
	"pos_report": "POS Report",
	"position": "Position",
	"posting_date": "Posting",
	"posting_date_si": "Posting Date",
	"pr_creator": "PR Creator",
	"pr_no": "PR NO",
	"pr_num": "PR No.",
	"prepay": "Prepay",
	"prepay_approved": "Prepayment Approved",
	"presale": "Presale",
	"presale_colonsign": "Presale:",
	"president_dashboard": "President Dashboard",
	"press_enter_for_emails": "Press Enter for more emails",
	"press_enter_to_confirm_serial": "Press Enter to Confirm Serial No",
	"press_enter_to_confirm_weights": "Press Enter to Confirm Weights",
	"prev_page": "< Prev",
	"preview": "",
	"previous": "Previous",
	"previous_orders": "",
	"price": "",
	"price_1": "Price 1",
	"price_2": "Price 2",
	"price_3": "Price 3",
	"price_4": "Price 4",
	"price_adjustment": "Price Adjustment",
	"price_adjustment_chart": "Price Adjustment Chart",
	"price_level": "",
	"price_level_percent": "Price Level Percent",
	"price_lvl": "Price LvL",
	"price_range_warning": "Input passcode to confirm your identity to process the previous action",
	"price_reference": "Price Reference",
	"price_reference_chart": "Price Reference Chart",
	"price_style_1": "Price as is",
	"price_style_2": "Round to 0,5,9",
	"price_table": "Price Table",
	"price_ticket": "Price Ticket",
	"pride_msg_print_shipping": "Warning: There are existing tracking numbers in selections. Continuing will overwrite them with new tracking numbers.",
	"pride_print": "Print Shipping Label",
	"print": "Print",
	"print_barcode": "Print Barcode",
	"print_bo": "Print BO",
	"print_bol": "Print BOL",
	"print_general_information": "Print General Information",
	"print_invoice": "Print Invoice",
	"print_label": "Print Label",
	"print_new_label": "Print New Label",
	"print_no": "Print No",
	"print_ns": "Print No $",
	"print_number": "Print No.",
	"print_picking_list": "Print Picking List",
	"print_po": "Print PO",
	"print_purchase_order": "Print Purchase Order",
	"print_purchase_payment": "Print Purchase Payment",
	"print_reminder": "Print Reminder",
	"print_shipping": "Print Shipping",
	"print_shipping_sheet": "Print Shipping Sheet",
	"print_si": "Print SI",
	"print_so": "Print SO",
	"print_specifications": "Print Specifications",
	"print_statements": "Print Statements",
	"printing_information": "Printing Information",
	"pro_num": "PRO Num",
	"process_purchase_return": "Process Purchase Return",
	"process_sales_return": "Process Sales Return",
	"processing_fee": "Processing Fee",
	"processing_order": "Processing Order",
	"processor/prison/military/airline/school/club": "Processor/Prison/Military/Airline/School/Club",
	"prod2_desc": "Prod 2 Desc",
	"prod2_name": "Prod 2 Name",
	"prod2_num": "Prod 2 No.",
	"prod2_qty": "Prod 2 Qty",
	"prod2_ref_num": "Prod 2 Ref No.",
	"prod_barcode": "Prod Barcode",
	"prod_cost": "Prod Cost",
	"prod_group": "Prod Group",
	"prod_name": "Prod Name",
	"prod_num": "Prod No.",
	"prod_type": "Prod Type",
	"product": "Product",
	"product_a": "Purchase Product (A)",
	"product_b": "Gift Product (B)",
	"product_barcode": "Product Barcode",
	"product_categories": "",
	"product_category_1": "",
	"product_category_2": "",
	"product_convert": "Product Convert",
	"product_convert_page": "Product Convert Page",
	"product_cost": "Product Cost",
	"product_cost_and_price": "Product Cost and Price",
	"product_description": "",
	"Product_Description": "Product Description",
	"product_detail": "",
	"Product_Detail_Info": "Product Detail Infomation",
	"product_details": "Product Details",
	"product_does_not_exist": "Product Does Not Exist",
	"product_filter": "Product",
	"product_group": "",
	"product_group_and_category": "Product Group and Category",
	"product_group_name": "Prod Group Name",
	"product_groups": "",
	"product_information": "Product Information",
	"product_list": "Product List",
	"product_location_detail": "Product Location Detail",
	"product_management": "",
	"product_mapping": "Product Mapping",
	"Product_Model": "Product Model",
	"product_name": "Product Name",
	"product_not_found": "Product not found.",
	"product_num": "Product No.",
	"product_num_ref_num": "Prod No. / Ref Style",
	"product_num_sku": "Prod No. / SKU",
	"product_num_sku_name": "Prod No. / SKU / Name",
	"product_price": "Product Price",
	"product_purchased": "Product Purchased",
	"product_ref_num": "Prod Ref No.",
	"product_repackage_sheet_product_repackage": "Product Repackage Sheet|Product Repackage",
	"Product_Serial_Number": "Product Serial Number",
	"product_sku": "Product SKU",
	"product_to_return": "Product to Return",
	"product_type": "",
	"product_unit_of_measure": "",
	"product_unit_weight_price": "Product Unit Weight Price",
	"products": "",
	"products_list": "Products List",
	"profile": "",
	"profit": "Profit",
	"profit_dollar": "Profit $",
	"profit_percentage": "",
	"profit_pl": "Profit",
	"promo": "Promo",
	"promo_code": "Promo Code",
	"promotion": "",
	"promotion_management": "Promotion Management",
	"promotion_name": "Promotion Name",
	"promotions": "",
	"Proposition65": "Proposition 65",
	"puchase_payment_detail": "Purchase Payment Detail",
	"pull_sheet_format": "Pull Sheet Format",
	"purchase": "Purchase",
	"purchase_convert_unit": "Purchase Convert Unit",
	"purchase_dashboard": "",
	"purchase_date": "",
	"purchase_date_colonsign": "Purchase Date:",
	"purchase_information": "",
	"purchase_management": "Purchase Management",
	"purchase_no": "Purchase No.",
	"purchase_order": "Purchase Order",
	"purchase_order_date": "Purchase Order Date",
	"purchase_order_dates": "Purchase Order Dates",
	"purchase_order_detail": "Purchase Order Detail",
	"purchase_order_details": "Purchase Order Details",
	"purchase_order_expect_coming_today": "Purchase Order Expect Coming Today",
	"purchase_order_full_list": "Purchase Order Full List",
	"purchase_order_full_table": "Purchase Order Full Table",
	"purchase_order_no": "Purchase Order No.",
	"purchase_order_not_received": "Purchase Order Not Received",
	"purchase_order_number": "Purchase Order Number: ",
	"purchase_order_receive_rate": "Purchase Order Receive Rate",
	"purchase_order_requires_products": "purchase order requires products",
	"purchase_orders_arrive_today": "Purchase Orders Scheduled To Arrive",
	"purchase_payment": "Purchase Payment",
	"purchase_payment_details": "Purchase Payment Details",
	"purchase_payments": "Purchase Payments",
	"purchase_performance": "Purchase Performance",
	"purchase_pivot": "Purchase Pivot",
	"purchase_pivot_chart": "Purchase Pivot Chart",
	"purchase_quote": "Purchase Quote",
	"purchase_quote_details": "Purchase Quote Details",
	"purchase_quote_full_table": "Purchase Quote Full Table",
	"purchase_reference": "Purchase Reference",
	"purchase_reference_report": "Purchase Reference Report",
	"purchase_report": "Purchase Report",
	"purchase_return": "Purchase Return",
	"purchase_return_details": "Purchase Return Details",
	"purchase_return_list": "Purchase Return List",
	"purchase_return_num": "Purchase Return Num",
	"purchase_sales": "RECEIVED / INVOICED",
	"purchase_schedule": "Purchase Schedule",
	"purchase_statistics": "Purchase Statistics",
	"purchase_status": "",
	"purchase_template": "Purchase Template",
	"purchase_template_details": "Purchase Template Details",
	"purchase_template_full_table": "Purchase Template Full Table",
	"purchase_template_must_have_products": "purchase template must have products",
	"purchase_template_no": "Purchase Template No.",
	"purchase_template_unavailable": "Purchase Template Unavailable",
	"purchase_user": "Purchase User",
	"purchased": "Purchased",
	"purchased_by": "",
	"purchased_colonsign": "Purchased:",
	"purchaser": "Purchaser",
	"purchaser_name": "",
	"purchasing": "",
	"purchasing_performance": "Purchasing Performance",
	"put_away": "",
	"put_away_form": "",
	"put_away_list": "Put Away List",
	"put_away_num": "Put Away Num",
	"putaway_quantity": "",
	"qb_msg": "QB Msg",
	"qb_status": "QB Status",
	"qc_status": "QC Status",
	"qty": "Qty",
	"qty_from": "Qty From",
	"qty_to": "Qty To",
	"qualified_qty": "Qualified Qty",
	"quality_control": "Quality Control",
	"quantity": "Quantity",
	"quantity_cannot_have_a_zero_value": "Quantity cannot have a zero value.",
	"quantity_colonsign": "Quantity:",
	"quantity_weight": "Qty / Wt",
	"quarter": "Quarter",
	"quick_actions": "Quick Actions",
	"quickbook_account": "QuickBook Account",
	"quote_date": "Quote Date",
	"quote_esp_date": "Quote Esp Date",
	"quote_reference": "Quote Reference",
	"quote_reference_chart": "Quote Reference Chart",
	"quote_reference_chart_detail": "Quote Reference Chart Detail",
	"quote_status": "Quote Status",
	"range": "Range",
	"rate": "Rate",
	"rcv_qty": "Rcv Qty",
	"rcv_quantity": "Rcv Quantity",
	"rcv_total_price": "Rcv Total Price",
	"rcv_weight": "Rcv Weight",
	"rcv_wt": "Rcv WT",
	"re_print": "Reprint",
	"reading_data": "Reading Data",
	"reason_for_return": "Reason for Return",
	"receipt": "Receipt",
	"receipt_no": "Receipt No.",
	"receive": "",
	"receive$": "Receive$",
	"receive_all": "Receive All",
	"receive_date": "Receive Date",
	"receive_detail": "",
	"receive_dollarsign": "Receive $",
	"receive_final_dollarsign": "Receive Final $",
	"receive_history": "Receive History",
	"receive_history_detail": "",
	"receive_history_finalize": "Finalize",
	"receive_list": "Receive List",
	"receive_num": "Receive No.",
	"receive_placed": "Placed",
	"receive_qty": "Receive Qty",
	"receive_total_dollarsign": "Receive Total $",
	"receive_total_price": "Receive Total Price",
	"receive_total_wt": "Receive Total Wt",
	"receive_unit_dollarsign": "Receive Unit $",
	"receive_unit_price": "",
	"received": "Received",
	"received_dollarsign": "Received $",
	"receiver": "Receiver",
	"receiving": "Receiving",
	"receiving_date": "Receiving Date",
	"receiving_details": "Receiving Details",
	"receiving_history": "Receiving History",
	"receiving_information": "Receiving Information",
	"receiving_list": "Receiving List",
	"record_adjustment_no": "Record (Adjustment) No.",
	"record_convert_no": "Record (Convert) No.",
	"record_relocation_no": "",
	"record_repackage_no": "Record (Repackage) No.",
	"record_scrap_no": "Record Scrap NO",
	"recreate": "Recreate",
	"ref_barcode": "Ref Barcode",
	"ref_cost": "Ref Cost",
	"ref_cost_price": "Ref Cost Price",
	"ref_dollarsign": "Ref $",
	"ref_num": "Ref No.",
	"ref_price": "Ref Price",
	"ref_purchasing_price": "",
	"ref_sales": "Ref Sales",
	"ref_style": "Ref Style#",
	"refer_purchasing_price": "Ref Price",
	"refresh_system": "Refresh System",
	"refund": "Refund",
	"refund_amount": "refund amount",
	"refund_successful": "Refund Successful",
	"reject_approve": "Reject",
	"reject_review": "Reject",
	"related": "Related",
	"related_no": "Related No.",
	"related_product": "Related Product",
	"release": "Release",
	"released": "Released",
	"Released": "Released",
	"related_po": "Related PO",
	"relocate": "Relocate",
	"relocate_quantity": "Relocate Quantity",
	"relocate_same_company": "Relocate(same company)",
	"relocate_some_or_all_of_the_selected_inventory": "Relocate some or all of the selected inventory",
	"relocate_user": "",
	"relocated": "Relocated",
	"relocated_so": "Relocated",
	"relocation": "Relocation",
	"relocation_date": "",
	"relocation_destination": "Relocation Destination",
	"relocation_quantity": "Relocation Quantity",
	"remark": "Remark",
	"remember_me": "Remember Me",
	"remove": "Remove",
	"remove_from_so_list": "",
	"repackage": "Repackage",
	"repackage_date": "Repackage Date",
	"repackage_destination": "Repackage Destination",
	"repackage_quantity": "Repackage Quantity",
	"repackage_target_quantity": "Repackage Target Quantity",
	"repackage_user": "Repackage User",
	"repair_detail": "Repair Detail",
	"Repair_Note": "Repair Note",
	"repeat_frequency": "Repeat Frequency",
	"repeat_interval": "Repeat Interval",
	"repeat_on": "Repeat On",
	"report": "Report",
	"report_file": "Report File",
	"report_modal_annotation1": "*Export product batches that are NOT expired within the selected date range",
	"report_modal_annotation1_special": "*Export product batches that are expired within the selected date range",
	"report_modal_annotation2": "*Export product purchase within the selected date range",
	"report_modal_annotation3": "*Export product sales within the selected date range",
	"report_modal_annotation3_sales": "Sales Reports of expired products within selected date range",
	"resale_no": "Resale No",
	"reseller": "Reseller",
	"reset_all": "Reset All",
	"reset_email": "Reset Email",
	"reset_location": "Reset Location",
	"reset_password": "Reset Password",
	"reset_picked_qty": "Reset Picked Qty",
	"reship": "Reship",
	"restaurant": "Restaurant",
	"restocking_fee": "Restocking Fee",
	"resync": "Resync",
	"retail_pack": "Retail Pack",
	"return": "Return",
	"return_date": "Return Date",
	"return_details": "Return Details",
	"return_dollarsign": "Return $",
	"return_final": "Return Final",
	"return_final_price": "RTN$",
	"Return_Logistics_Company": "Return Logistics Company",
	"return_no": "Return No.",
	"return_order_info": "Return Order Info",
	"return_qty": "Return Qty",
	"return_quantity": "",
	"return_reason": "Return Reason",
	"return_status": "Return Status",
	"return_this_product": "",
	"return_total": "Return Total",
	"Return_Tracking_Number": "Return Tracking Number",
	"return_unit_price": "",
	"returns": "Returns",
	"retype_password": "Retype Password",
	"review_status": "Review Status",
	"reviewing": "Reviewing",
	"revoke": "Revoke",
	"rewards": "Rewards",
	"rma": "RMA",
	"RMA_Content": "RMA Content",
	"rma_form": "RMA Form",
	"rma_id": "RMA ID",
	"rma_num": "RMA No.",
	"RMA_Number": "RMA Number",
	"RMA_Service_Type": "RMA Service Type",
	"role_management": "Role Management",
	"role_name": "Role Name",
	"roll_back": "Restock",
	"route": "Route",
	"route_details": "Route Details",
	"route_id": "Route ID",
	"route_num": "Route Num",
	"route_number": "Route Number",
	"routing": "",
	"rtn_date": "RTN Date",
	"rtn_or_serial_no_search": "Return / Serial No. search",
	"rtn_qty": "RTN Qty",
	"rtn_quantity": "Rtn Quantity",
	"rtn_weight": "RTN WT",
	"rtned_qty": "Returned QTY",
	"sa_file_no": "SA/File No.",
	"sa_no": "SA No.",
	"sa_report": "SA Report",
	"sa_scheduled_arrival": "SA Scheduled Arrival",
	"sa_status": "SA Status",
	"sale": "Sale",
	"sale_details": "Sale Details",
	"sale_dollarsign": "Sale $",
	"sale_invoice_details": "Sale Invoice Details",
	"sale_order_details": "Sale Order Details",
	"sale_price": "Sale Price",
	"sale_qty": "Sale Qty",
	"sale_wt": "Sale WT",
	"saleable": "",
	"sales": "Sales",
	"sales_colonsign": "Sales:",
	"sales_convert_unit": "Sales Convert Unit",
	"sales_cost": "Sales / Cost",
	"sales_dashboard": "Sales Dashboard",
	"sales_history": "Sales History",
	"sales_inventory_value": "Sales Value/Inventory Value",
	"sales_invoice": "Sales Invoice",
	"sales_invoice_detail": "",
	"sales_invoice_details": "Sales Invoice Details",
	"sales_invoice_full_table": "",
	"sales_invoices_today": "Sales Invoices Today",
	"sales_management": "Sales Management",
	"sales_margin_master_percentsign": "Sales Margin %",
	"sales_margin_percentsign": "Sales Margin %",
	"sales_order": "Sales Order",
	"sales_order_dates": "Sales Order Dates",
	"sales_order_details": "Sales Order Details",
	"sales_order_full_table": "",
	"sales_order_list": "Sales Order List",
	"sales_order_no": "",
	"sales_order_rate": "Sales Order Rate",
	"sales_orders": "Sales Orders",
	"sales_orders_open": "Sales Orders Open",
	"sales_orders_ship_today": "Sales Orders Scheduled To Ship Today",
	"sales_performance": "Sales Performance",
	"sales_performance_list": "Sales Performance List",
	"sales_popularity": "Sales Popularity",
	"sales_popularity_class": "Sales Popularity Class",
	"sales_price_levels": "Sales Price Levels",
	"sales_report": "Sales Report",
	"sales_return": "Sales Return",
	"sales_returned": "Sales Returned",
	"sales_type": "Sales Type",
	"same_as_billing_address": "Same as Billing Address",
	"same_as_billing_contact": "Same as Billing Contact",
	"same_as_billing_information": "Same as Billing Information",
	"Sat": "Sat",
	"sat_route": "Sat Route",
	"sat_stop": "Sat Stop",
	"saturday": "Saturday",
	"save": "Save",
	"save_and_print": "Save and Print",
	"save_changes": "Save Changes",
	"save_completed": "Save Completed Navigate To New Receiving",
	"save_draft": "Save Draft",
	"save_successful": "Save Successful",
	"save_weights": "Save Weights",
	"saved": "Saved",
	"saved_tracking_note": "Tracking Notation saved for this Purchase Order",
	"scac": "SCAC",
	"schedule_shipping_date": "",
	"scheduled": "Scheduled",
	"scheduled_shipping_date": "Scheduled Shipping Date",
	"scheduled_to_ship": "Scheduled to Ship",
	"scm_user_management": "SCM User Management",
	"scrap": "Scrap",
	"scrap_amount": "Scrap Amount",
	"scrap_date": "Scrap Date",
	"scrap_product_details": "Scrap Product Details",
	"scrap_qty": "Scrap Qty",
	"scrap_quantity": "Scrap Quantity",
	"scrap_record": "Scrap Record",
	"scrap_records": "Scrap Records",
	"scrap_some_or_all_of_the_selected_inventory": "Scrap Some or all of the Selected Inventory",
	"scrapping": "Scrapping",
	"search": "Search",
	"search_by": "Search Product by:",
	"search_prod": "Search Product:",
	"search_prod_by": "Search Prod by:",
	"search_type": "Search Type:",
	"sectioned_list": "Sectioned List",
	"select": "Select",
	"select_a_product_to_scrap": "Select A Product To Scrap",
	"select_a_purchase_order": "Select a Purchase Order",
	"select_an_inventory_item": "",
	"select_customer_information": "Select Customer Information",
	"select_group": "Select Group",
	"select_inventory_to_scrap": "Select Inventory To Scrap",
	"select_purchase_template": "Select Purchase Template",
	"select_purchaser": "Select Purchaser",
	"select_receive_history": "",
	"select_seller": "Select Seller",
	"select_serial_num": "Select Serial No.",
	"select_vendor": "Select Vendor",
	"selected_bins": "",
	"selected_sales_orders": "Selected Orders",
	"seller": "Seller",
	"send_po": "Send PO",
	"send_so": "Send SO",
	"send_sq": "Send SQ",
	"serial_no": "SERIAL NO",
	"serial_no(s)_cannot_have_a_zero_value": "Serial num(s) cannot have a zero value.",
	"service_code": "Service Code",
	"set_order": "Set Order",
	"set_po": "Set And Merge",
	"set_products_serial_num": "Set Products Serial No.",
	"set_schedule": "Set Schedule",
	"set_serial_no": "SET SERIAL NO.",
	"set_total_weight": "Set Total Wt",
	"set_various_weight": "",
	"set_weights": "Set Weights",
	"setting": "Setting",
	"share": "Share",
	"share_cost": "Share Cost",
	"sheet_not_completed_warning": "",
	"shelf_life": "Shelf Life",
	"shelf_life_statistics": "Shelf Life Statistics",
	"shift_life_day": "Shift Life (Day)",
	"ship_by": "Ship By",
	"ship_date": "Ship Date",
	"ship_dollarsign": "Ship $",
	"ship_method": "Ship Method",
	"ship_subtotal": "Ship. Sub",
	"ship_to": "Ship-To",
	"ship_to_address": "Ship To Address",
	"ship_weight": "Ship Wt",
	"ship_wt": "Ship Wt",
	"shipment_date": "",
	"shipped": "Shipped",
	"shipped_case_qty": "Shipped Case Qty",
	"shipped_qty": "Shipped Qty",
	"shipped_wt": "Shipped Wt",
	"shipping": "",
	"shipping_address": "Shipping Address",
	"shipping_address_poundsign": "Shipping Address #",
	"shipping_advice": "Shipping Advice",
	"shipping_advice_details": "Shipping Advice Details",
	"shipping_amount": "Shipping Amount",
	"shipping_cost": "",
	"Shipping_Cost": "Shipping Fee",
	"shipping_cost_details": "Shipping Cost Details",
	"shipping_cost_information": "Shipping Cost Information",
	"shipping_date": "",
	"shipping_detail": "Shipping Detail",
	"shipping_details": "Shipping Details",
	"shipping_dollarsign": "Shipping $",
	"shipping_fee": "Shipping Fee",
	"Shipping_fee": "Shipping$",
	"shipping_information": "Shipping Information",
	"shipping_label": "Shipping Label",
	"shipping_method": "Shipping Method",
	"shipping_name": "Shipping Name",
	"shipping_poundsign": "Shipping #",
	"shipping_status": "Shipping Status",
	"shipping_weight": "Shipping Weight",
	"shipto": "Ship To",
	"shopify_sync": "Shopify Sync",
	"show": "Show",
	"show_as": "Show As",
	"show_finalized_si": "",
	"show_price": "Show Price",
	"show_released_si": "",
	"si_date": "SI Date",
	"si_dollarsign": "SI$",
	"si_final": "SI Final",
	"si_no": "SI No.",
	"si_num": "SI No.",
	"si_payment": "SI Payment",
	"si_status": "SI Status",
	"sign_in_to_continue": "Sign In to Continue",
	"signature": "signature",
	"simplified_excel": "Simplified Excel",
	"simplified_statement": "Simplified Statement",
	"simplified_statement_only": "simplified statement only",
	"size": "Size",
	"size_ratio": "Size Ratio",
	"sku": "SKU",
	"sku_num": "SKU Num",
	"sku_num_format_error": "SKU Num format error",
	"sm": "Sm",
	"small_catch_weight": "Sm Catch Wt",
	"small_label_mac": "S-MAC",
	"small_label_win": "S-WIN",
	"small_net_weight": "Sm Net Wt",
	"small_pr": "Small Unit",
	"small_product_no": "Sm Prod No.",
	"small_un": "SM$",
	"small_unit_price": "Small Unit Price",
	"SO": "SO",
	"so_create_mfg_or_pr": "After clicking confirm, the system will automatically create MFG or PR",
	"so_create_pr": "After clicking confirm, the system will automatically create a PR",
	"so_dollarsign": "SO$",
	"so_no": "SO No.",
	"so_order_date": "Order Date",
	"so_packing": "SO Packing",
	"so_purchased": "Purchased",
	"so_scheduled_shipping": "SO Scheduled Shipping",
	"so_scheduled_shipping_up": "SO Scheduled Shipping",
	"so_to_po": "SO to PO",
	"so_usable": "On Hand",
	"sold": "Sold",
	"soso": "SOSO",
	"space_not_enough_create_bins": "\"The space is not enough. Do you want to create new bins?\"",
	"space_not_enough_relocate": "\"The space is not enough. Do you want to relocate?\"",
	"specify": "Specify",
	"split": "Split",
	"split_qty": "Split Qty.",
	"split_so": "Split SO",
	"split_tracking_numbers": "Split Tracking Numbers",
	"split_unit_price": "Split Unit Price$",
	"spreadsheet": "Import Spreadsheet",
	"ssn": "SSN",
	"start": "Start",
	"start_date": "Start Date",
	"state": "State",
	"statement": "Statement",
	"statement_range": "Statement Range",
	"status": "Status",
	"Status": "Status",
	"stock": "Stock",
	"stock_left_after_1_week": "Stock Left After 1 Week",
	"stock_range": "Stock Range",
	"stop": "Stop",
	"stop_purchase": "Stop Purchase",
	"stop_route": "Stop Route",
	"stop_sale": "Stop Sale",
	"stopsale": "",
	"storage": "Storage",
	"storage_rate": "Storage Rate",
	"store_credit_dollarsign": "Store Credit $",
	"street": "",
	"style": "Style",
	"sytle_composition": "Style's Composition",
	"style_detail": "Style Detail",
	"style_list": "Style List",
	"sub_menu": "",
	"submit": "Submit",
	"submit_image": "Submit Image",
	"submit_pending": "Pending",
	"subtitle": "",
	"subtotal": "Subtotal",
	"subtotal_pr": "Subtotal$",
	"success": "Success",
	"success_created_pick": "Successfully created picking list, tracking number: ",
	"suite": "Suite",
	"Sun": "Sun",
	"sun_route": "Sun Route",
	"sun_stop": "Sun Stop",
	"surcharge": "Surcharge",
	"sync_esl": "Sync ESL",
	"sync_scale": "Sync Scales",
	"sync_to_mes": "Sync to MES",
	"sync_to_QB": "Sync to QB",
	"synced": "Synced",
	"target_weight": "Target Weight",
	"tax": "",
	"Tax": "Tax:",
	"tax_code": "Tax Code",
	"tax_management": "Tax Management",
	"taxable": "",
	"tel": "Tel",
	"tel_colonsign": "Tel:",
	"telephone": "Telephone",
	"temperature": "Temperature",
	"template_name": "Template Name",
	"term_days": "Term Days",
	"term_type": "Term Type",
	"term_types": "",
	"test": "test",
	"text_po": "Text PO",
	"this_customer_is_already_in_the_group": "This customer is already in the group.",
	"this_group": "this group",
	"thu_route": "Thu Route",
	"thu_stop": "Thu Stop",
	"Thur": "Thur",
	"thurs_route": "Thurs Route",
	"thurs_stop": "Thurs Stop",
	"to": "To",
	"to_bin": "To Bin",
	"to_zone": "To Zone",
	"today": "Today",
	"tomorrow": "Tomorrow",
	"tooltip_customer_bypass_payment": "Bypassing payments will let mobile users skip mobile payment, and pay with AR.",
	"tooltip_customer_manager": "Manager users can see all past orders for this business customer.",
	"top_deal": "Top Deal",
	"total": "Total",
	"total_amount": "Total Amount",
	"total_bin": "",
	"total_bins": "Total Bins",
	"total_credit": "Total Credit",
	"total_customers": "Total Customers",
	"total_delivery_fee": "Delivery Fee",
	"total_dollarsign": "Total $",
	"total_final": "Total Final",
	"total_final_price_calc": "Total Final Price = Total Sales + Store Credit - Voided",
	"total_inventory_price": "Total Inventory Price",
	"total_inventory_worth": "Total Inventory Worth",
	"total_invoice": "Total Invoice",
	"total_invoiced_calc": "Total Invoiced = SO Invoiced + MSO Invoiced + POS Receipt",
	"total_net_weight": "Total Net Weight",
	"total_net_wt": "Total Net Wt",
	"total_order_qty": "Total Order Qty",
	"total_orders_today": "Total Orders Today",
	"total_picked_qty": "Total Picked Qty",
	"total_price": "Total Price",
	"total_price_colonsign": "Total Price:",
	"total_prod": "Total Prod",
	"total_profit": "Total Profit",
	"total_purchases": "Total Purchases",
	"total_qty": "Total QTY",
	"total_receive_price": "Total Receive Price",
	"total_receive_qty": "Total Received Qty",
	"total_receive_wt": "Total Received Wt",
	"total_received_final": "Total Received Final",
	"total_received_ty": "Total Received Qty",
	"total_received_wt": "Total Received Wt",
	"total_return": "Total Return",
	"total_s_weight": "Total S.WT.",
	"total_sale": "Total Sale",
	"total_sale_pr": "Total Sale $",
	"total_sales_invoices": "Total Sales Invoices",
	"total_sales_price": "Total Sales Price",
	"total_sales_price_calc": "Total Sales Price = Sales Order + Mobile Sales Order + POS Order",
	"total_sales_worth": "Total Sales Worth",
	"total_ship_qty": "Total Ship Qty",
	"total_ship_wt": "Total Ship Wt",
	"total_shipping_weight": "Total Shipping Weight",
	"total_shipping_weight_lbs": "Total Shipping Weight (lbs)",
	"total_size": "",
	"total_storage_day": "Total Storage Day",
	"total_unit": "Total Unit",
	"total_users": "Total Users",
	"total_weight": "Total Wt",
	"total_weight_lb": "Total Wt (lbs)",
	"total_wt": "Total Wt",
	"wt": "Wt",
	"track_all": "Track All",
	"track_no": "Track No.",
	"tracking_note": "Tracking Note",
	"tracking_num": "Tracking Num",
	"tracking_number": "Tracking No.",
	"tracking_nums": "Tracking Nums",
	"transaction_fee": "Trans. Fee",
	"transfer_different_company": "Transfer(different company)",
	"transfer_order": "Transfer Order",
	"transit_method": "",
	"translation": "Translation",
	"try_dropping_some_files_here,_or_click_to_select_files_to_upload": "Try Dropping some files here, or click to select files to upload",
	"tue_route": "Tue Route",
	"tue_stop": "Tue Stop",
	"Tues": "Tues",
	"tues_stop": "Tues Stop",
	"type": "Type",
	"type_in_your_email": "Type In Your Email",
	"type_in_your_password": "Type In Your Password",
	"Typo": "Correction",
	"unassigned_orders": "Unassigned Orders",
	"undo": "Undo",
	"undone": "Undone",
	"unfreeze": "Unfreeze",
	"unit": "",
	"unit/case": "Unit/Case",
	"unit_cost": "Unit Cost $",
	"unit_dimension": "Unit Dim.",
	"unit_dollarsign": "Unit $",
	"unit_of_measure": "Unit Of Measure",
	"unit_per_pallet": "Unit Per Pallet",
	"unit_price": "Unit Price",
	"unit_price_dollar": "Unit $",
	"unit_price_colonsign": "Unit Price:",
	"unit_qty": "Unit Qty",
	"unit_type": "Unit Type",
	"unload_all": "Unload All",
	"unload_selected": "Unload Selected",
	"unpaid": "Unpaid",
	"unpaid_amount": "Unpaid Amount",
	"unqualified_qty": "Unqualified Qty",
	"unsynced": "Unsynced",
	"update": "Update",
	"update_ctn_no": "Update CTN No.",
	"update_date": "",
	"update_dollarsign": "Update $",
	"update_inventory": "Update Inventory",
	"update_isa_no": "Update ISA No.",
	"update_no": "Update No.",
	"update_time": "",
	"upload": "Upload",
	"upload_file": "Upload File",
	"upload_files": "Upload Files",
	"upload_image": "Upload Image",
	"upload_images": "Upload Images",
	"upload_po": "Upload PO",
	"upload_pod": "Upload POD",
	"upload_so": "Upload SO",
	"uploading": "",
	"url": "URL",
	"us_size": "US Size",
	"usable": "Usable",
	"use_product_a": "Use Product A",
	"used_bin": "",
	"user": "User",
	"user_amount": "User Amount",
	"user_detail": "User Detail",
	"user_management": "User Management",
	"user_name": "User Name",
	"user_performance": "User Performance",
	"user_role": "",
	"username": "Username",
	"variable_weight": "",
	"vehicle": "Vehicle",
	"vendor": "Vendor",
	"vendor_add": "Vendor Add",
	"vendor_description": "Vendor Description",
	"vendor_details": "Vendor Details",
	"vendor_id": "Vendor ID",
	"vendor_information": "Vendor Information",
	"vendor_inv": "Vendor Inv. No.",
	"vendor_inv_date": "Vendor Inv. Date",
	"vendor_invoice_no": "Vendor Invoice No.",
	"vendor_name": "Vendor Name",
	"vendor_no": "Vendor No",
	"vendor_num": "Vendor Num",
	"vendor_number": "Vendor Number",
	"vendor_poundsign": "Vendor #",
	"vendor_product_num": "Vendor Pro No",
	"vendor_product_number": "Vendor Product Number",
	"vendor_products": "Vendor Products",
	"vendor_statement": "Vendor Statement",
	"vendors": "Vendors",
	"vendors_management": "Vendors Management",
	"vessel_no": "Vessel No.",
	"view_pos_order": "View Pos Order",
	"view_serial_num": "Serial No Details",
	"vk": "VK",
	"void": "Void",
	"void_note": "Void Note",
	"void_reason": "Void Reason",
	"volume_cft": "Volume (CFT)",
	"vp_code": "VPCode",
	"VPN": "VPN",
	"vpn": "VPN",
	"walmart_shipment": "Walmart Shipment",
	"walmartb2b": "Walmart B2B",
	"warehouse": "Warehouse",
	"warehouse_bin_id": "Warehouse Bin ID",
	"warehouse_bins": "Warehouse Bins",
	"Warehouse_Check_Info": "Warehouse Checking Infomation",
	"warehouse_dashboard": "Warehouse Dashboard",
	"warehouse_detail_view": "Warehouse Detail View",
	"warehouse_id": "Warehouse ID",
	"warehouse_management": "Warehouse Management",
	"warehouse_map_view": "Warehouse Map View",
	"warehouse_name": "Warehouse Name",
	"warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_partially_received_": "Warehouse receive deleted. Purchase order's PurchaseStatus rolled back to Partially Received.",
	"Warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_placed_": "Warehouse receive deleted. Purchase order’s PurchaseStatus rolled back to Placed.",
	"warehouse_receive_num": "",
	"warehouse_zone_id": "",
	"warehousebin_id": "",
	"warning": "Warning",
	"wechat": "WeChat",
	"Wed": "Wed",
	"wed_route": "Wed Route",
	"wed_stop": "Wed Stop",
	"Weekly": "Weekly",
	"weeks_left_after_1_week": "Weeks Left After 1 Week",
	"weight": "Weight",
	"weight(s)_cannot_have_a_zero_value": "Weight(s) cannot have a zero value.",
	"weight_lbs": "Weight (lbs)",
	"weight_not_in_range": "One or more of items weight are not in the weight range of this product",
	"weight_range": "Weight Range",
	"weight_return": "Weight Return",
	"wfcg": "Wayfair CG",
	"wh": "WH",
	"wh_stock": "Stock(WH)",
	"wholesale": "Wholesale",
	"wholesale/distributor": "Wholesale/Distributor",
	"wholesale_only": "Wholesale Only",
	"will_call_orders": "Will Call Orders",
	"wk_sale": "WK Sale",
	"work_not_saved_warning": "Your work is not saved! Are you sure you want to leave?",
	"working_order": "Working Order",
	"working_orders": "Working Orders",
	"year": "Year",
	"year_in_business": "Year in business",
	"yes": "Yes",
	"yesterday": "Yesterday",
	"your_order": "Your Order",
	"your_passcode_is_not_correct": "Passcode is not correct",
	"your_purchase_order": "Your Purchase Order",
	"your_purchase_quote": "Your Purchase Quote",
	"your_purchase_template": "Your Purchase Template",
	"your_quote_no_period_is": "Your Quote No. is:",
	"your_return_order": "Your Return Order",
	"your_sales_order": "Your Sales Order",
	"your_so_no_period_is": "Your Sales Order No. is:",
	"zip": "Zip",
	"zipcode": "Zipcode",
	"zone": "Zone",
	"zone_description": "",
	"zone_detail": "",
	"zone_detail_view": "",
	"zone_id": "Zone ID",
	"zone_level": "",
	"zone_name": "Zone Name",
	"zone_no": "Zone No.",
	"inv_rtn_date": "Inv/Rtn Date",
	"inv_rtn_num": "Inv/Rtn No.",
	"total_item_sale": "Total Item Sale $",
	"so_template": "SO Template"
};


//////////////////
// WEBPACK FOOTER
// ./master/i18n/en.json
// module id = 816
// module chunks = 0